import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-localizador-veiculo',
  templateUrl: './consulta-localizador-veiculo.component.html',
  styleUrls: ['./consulta-localizador-veiculo.component.scss']
})
export class ConsultaLocalizadorVeiculoComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() {}

  ngOnChanges() {

  }

  getMsg(){
    if(this.consulta && this.consulta.lista && this.consulta.lista.length > 1){
      return {status: 'warning', msg: "FORAM ENCONTRADOS" +  this.consulta.lista.length + "VEÍCULOS COM O MESMO NÚMERO DE MOTOR"}
    }
    return {status: 'info', msg: null}
  }

}
